module.exports = __webpack_public_path__ + "img/question-octagon.16d0a3ea.svg";